import GithubSlugger from "github-slugger";

export interface Heading {
  level: number;
  text: string;
  slug: string;
}

/** Strip the most common inline Markdown syntax so slugs match rehype-slug's rendered-text-based ids. */
function stripInlineMarkdown(text: string): string {
  return text
    .replace(/`([^`]+)`/g, "$1")
    .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
    .replace(/[*_]{1,3}([^*_]+)[*_]{1,3}/g, "$1")
    .trim();
}

/**
 * Extract ALL headings in document order (not just chapters) and slug them with a single
 * GithubSlugger instance — the same algorithm rehype-slug applies when rendering the full
 * document — so a slug computed here always matches the actual heading id in the DOM.
 */
export function extractHeadings(markdown: string): Heading[] {
  const slugger = new GithubSlugger();
  const headings: Heading[] = [];
  let inFence = false;
  for (const line of markdown.split("\n")) {
    if (/^\s*```/.test(line)) {
      inFence = !inFence;
      continue;
    }
    if (inFence) continue;
    const match = /^(#{1,6})\s+(.*)$/.exec(line);
    if (!match) continue;
    const level = match[1].length;
    const text = stripInlineMarkdown(match[2]);
    if (!text) continue;
    const slug = slugger.slug(text);
    headings.push({ level, text, slug });
  }
  return headings;
}

/** Chapter TOC entries — Boort chapters are `##` headings; `#` is reserved for the book title. */
export function extractChapterHeadings(markdown: string): Heading[] {
  return extractHeadings(markdown).filter((h) => h.level === 2);
}
